import { render } from "./IntegrationDetail.vue?vue&type=template&id=65e2dfa0"
import script from "./IntegrationDetail.vue?vue&type=script&lang=js"
export * from "./IntegrationDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__